import { AppBar, Box, Stack } from '@mui/material';
import Logo from '@/app/assets/icons/finmakon-logo.svg?react';
import { LangSwitcher } from '../lang-switcher';
import { ProfileCompanyMenu } from './ui/profile-company-menu';
import { HeaderNav } from './ui/header-nav';
import { Link, useLocation } from 'react-router-dom';
import { useAppSelector } from '@/app/hooks';
import { HeaderBurger } from './ui/header-burger';
import { NotificationCenter } from '../notification-center';

export const Header = () => {
  const { pathname } = useLocation();
  const { cabinetType } = useAppSelector((state) => state.auth);

  const isHomePage = pathname === '/';
  const authorizatedLink =
    cabinetType === 'sellerOrBuyer' ? '/seller' : '/factor';

  return (
    <AppBar
      position='relative'
      color='transparent'
      elevation={0}
      sx={{
        px: 2.5,
        pt: 1.5,
      }}
    >
      <Stack direction='row' alignItems='center' justifyContent='space-between'>
        <Stack direction='row' spacing={1.5} alignItems='center'>
          <HeaderBurger />
          <Box
            component={Link}
            to={isHomePage ? '#' : cabinetType ? authorizatedLink : '/'}
            sx={{
              display: 'flex',
            }}
          >
            <Box component={Logo} />
          </Box>
        </Stack>
        <HeaderNav />
        <Stack direction='row' spacing={2} alignItems='center'>
          <ProfileCompanyMenu />
          <NotificationCenter />
          <LangSwitcher />
        </Stack>
      </Stack>
    </AppBar>
  );
};
